module.exports = __webpack_public_path__ + "img/social-luxury-bag.9005e762.jpg";